import { useTranslate } from '@tolgee/react';
import { useQuery } from 'components/RouterQuery';
import { PageRoute, ScenarioPage, ScenarioPageProps } from '../components/Page';
import useEntryTrack from '../hooks/useEntryTrack';
import {
  cancellingIcon,
  cancellingTradeScenarios,
  getRouteAccess,
  platformGatherScenariosMap,
  shopeeCancelTradeScenarios,
} from '../Scenario/config';
import createRoute from '../Scenario/createRoute';
import useScenarioLabel from '../hooks/useScenarioLabel';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

export const saveOrderRouteAccess = getRouteAccess('配置弃单挽回任务');

const pageRoute = createRoute('saveOrder');

export const route: ScenarioPageProps['route'] = {
  ...pageRoute,
  element: <SaveOrder />,
  access: saveOrderRouteAccess,
};

function SaveOrder() {
  useEntryTrack('aide/refund');

  const { t } = useTranslate();

  const { platform } = useQuery();

  const { getScenarioI18nKey } = useScenarioLabel();

  const { whiteListConfig: { AIDE_REMOVE_TASK } = {} } = useOrgConfigStateValue();

  const { [platform as keyof typeof platformGatherScenariosMap]: gatherScenariosMap } =
    platformGatherScenariosMap;

  if (!gatherScenariosMap) {
    return <ScenarioPage route={pageRoute} />;
  }

  const { children: gatherChildren } = pageRoute;

  return (
    <ScenarioPage
      route={{
        ...pageRoute,
        children: gatherChildren.reduce<PageRoute[]>((res, gatherChild) => {
          const { path, children: scenarioChildren } = gatherChild;

          const { [path as keyof typeof gatherScenariosMap]: scenarios } = gatherScenariosMap;

          if (!scenarios || !scenarioChildren) {
            res.push(gatherChild);
            return res;
          }

          if (scenarios.length === 0) {
            return res;
          }

          let _scenarios = scenarios;

          if (AIDE_REMOVE_TASK && isTiKTokUpperCase(platform) && path === 'returnTrade') {
            _scenarios = [..._scenarios, 'RETURN_TRADE_ITEM_NOT_FIT', 'RETURN_TRADE_OTHER'];
          }

          res.push({
            ...gatherChild,
            children: _scenarios.reduce((res, scenario) => {
              const scenarioChild = scenarioChildren.find(({ path }) => path === scenario);

              if (!scenarioChild) {
                return res;
              }

              const { path } = scenarioChild;

              if (
                platform === 'SHOPEE' &&
                shopeeCancelTradeScenarios.includes(path as any) &&
                cancellingTradeScenarios.includes(path as any)
              ) {
                res.push({
                  ...scenarioChild,
                  menu: {
                    ...scenarioChild.menu,
                    label: scenarioChild.menu?.label || t(scenarioChild.i18nHelmetTitle),
                    icon: cancellingIcon,
                  },
                });

                return res;
              }

              res.push({
                ...scenarioChild,
                i18nHelmetTitle:
                  getScenarioI18nKey(path as any, platform) || scenarioChild.i18nHelmetTitle,
              });

              return res;
            }, [] as typeof scenarioChildren),
          });

          return res;
        }, []),
      }}
    />
  );
}

export default SaveOrder;
